import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AdminUsersAddPage } from './admin-users-add';

@NgModule({
  declarations: [
    AdminUsersAddPage,
  ],
  imports: [
    IonicPageModule.forChild(AdminUsersAddPage),
  ],
})
export class AdminUsersAddPageModule {}



// WEBPACK FOOTER //
// ./src/pages/admin-users-add/admin-users-add.module.ts